module.exports = __webpack_public_path__ + "media/Resources/Whitepaper-2af087d8.svg";